export default __webpack_public_path__ + "static/media/Inc4.0.777308eb.png";